import { FormSpecification } from "../../interface/type/form-specification.type";
import { MigrationType } from "../../persistence/dto/migration-type.enum";
import { IdentityConverter } from "../converter/identity.converter";
import { AlwaysValidValidator } from "../validator/always-valid.validator";

	/**
	 * @description
	 *  Formulario de configuración de migración de revendedoras.
	 */

export const MigrationConfigurationForm: FormSpecification = {

	"migrationType": {
		crossValidator: false,
		default: MigrationType.CreateStructureIfNotExists,
		validatorFactory: AlwaysValidValidator,
		converter: IdentityConverter,
		errors: []
	}
};
